import React, { useEffect, useState } from "react";

const Footer = ({ footerAPI: { titles, links } }) => {
  const [Year, setYear] = useState();

  useEffect(() => {
    const getYear = () => setYear(new Date().getFullYear());
    getYear();
  }, []);

  return (
    <>
      <footer className="bg-theme pt-7 pb-5">
        <div className="nike-container text-slate-200">
          <div className="grid items-start grid-cols-3 max-w-2xl w-full m-auto md:max-w-none md:gap-5">
            {titles.map((val, i) => (
              <div key={i} className="grid items-center">
                <h1 className="text-lg lg:text-base md:text-sm uppercase font-semibold mb-5">
                  {val.title}
                </h1>
              </div>
            ))}
            {links.map((list, i) => (
              <ul key={i} className="grid items-center gap-1">
                {list.map((link, i) => (
                  <li
                    key={i}
                    className="text-sm sm:text-xs hover:cursor-pointer hover:scale-110
                    ease-in-out duration-200 p-0.5">
                    {link.link}
                  </li>
                ))}
              </ul>
            ))}
          </div>
          <div className="mt-5 text-center">
            <p className="text-sm md:text-center">
              Copyright<sup className="text-base font-bold">&copy;</sup> All
              Rights Reserved{" "}
              <span className="font-semibold">Mr: "K" {Year}</span>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
